<template>
  <div>
    <main>
      <section>
        <div class="container">
          <div class="row">
            <mobileUserNav></mobileUserNav>

            <userInfo></userInfo>

            <div class="col_xl_8 col_l_8 col_m_8 col_s_12" v-if="!loading">
              <template v-if="addNewRoomMode">
                <p class="user_title" v-if="!roomEditMode && rooms.length == 0">
                  Please, set up the room name
                </p>

                <p class="user_title" v-if="!roomEditMode && rooms.length != 0">
                  Please, set up the room name
                </p>

                <p class="user_title" v-if="roomEditMode">Edit room info</p>

                <inputWrap
                    :title="'Room name'"
                    :type="'text'"
                    :inputData.sync="roomName"
                    :errorText="'Room name can not be empty'"
                    :hasError="hasError"
                    :placeholder="'e.g., sallydennis'"
                ></inputWrap>

                <button
                    class="color_btn create_room"
                    v-if="!roomEditMode"
                    @click="roomAddClick()"
                >
                  Create room
                </button>

                <button
                    class="color_btn create_room"
                    v-if="roomEditMode"
                    @click="editRoom(editRoomId, roomName)"
                >
                  Save changes
                </button>
              </template>

              <template v-else>
                <p class="user_title" v-if="$store.state.user">
                  Welcome,
                  {{
                    $store.state.user.given_name
                        ? $store.state.user.given_name
                        : $store.state.user.name
                  }}!
                </p>

                <p class="rooms">Your personal room(s)</p>

                <template v-if="rooms != null">
                  <div class="room_link" v-for="room in rooms" :key="room.id">
                    <div class="user_room_name">
                      <a v-bind:href="`/room/${room.nickname}`" class="hover_op"
                      >{{ shareLink }}{{ room.nickname }}
                      </a>
                    </div>

                    <div class="df align_center recs_wrap">
                      <button
                          class="hover_op recs"
                          @click="showRecordingsModal(room)"
                          v-if="room.meetings.length > 0"
                          :class="{ active: room.meetings.length !== 0 }"
                      >
                        <span>
                          Recording(s):
                          {{ room.meetings.length }}
                        </span>
                        <img src="@/assets/img/camera_icon.svg" alt=""/>
                      </button>

                      <clickToCopy
                          :text="shareLink + room.nickname"
                      ></clickToCopy>

                      <userRoomDrop
                          @removeBtnClick="removeRoom(room.id)"
                          @editBtnClick="roomEditClick(room)"
                          @duplicateBtnClick="duplicateRoom(room.id)"
                      ></userRoomDrop>
                    </div>
                  </div>
                </template>

                <button class="add_room hover_op" @click="addNewRoom">
                  Add more rooms
                </button>
              </template>
            </div>

            <img
                src="@/assets/img/preloader_icon.svg"
                alt=""
                class="preloader"
                v-if="loading"
            />
          </div>
        </div>
      </section>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";
import inputWrap from "@/components/inputWrap.vue";
import userInfo from "@/components/userInfo.vue";
import userRoomDrop from "@/components/userRoomDrop.vue";
import clickToCopy from "@/components/clickToCopy.vue";
import Axios from "axios";
import mobileUserNav from "@/components/mobileUserNav.vue";

export default {
  name: "User_rooms",

  components: {
    inputWrap,
    userInfo,
    footerComponent,
    userRoomDrop,
    clickToCopy,
    mobileUserNav,
  },

  data() {
    return {
      copyFrom: null,
      loading: true,
      addNewRoomMode: false,
      roomEditMode: false,
      hasError: false,
      roomName: "",
      editRoomId: "",
      transcripts: [],
      room_capacity: 100,
    };
  },

  methods: {
    duplicateRoom(roomId) {
      this.copyFrom = roomId
      this.addNewRoom()
    },
    roomEditClick(room) {
      this.addNewRoomMode = true;
      this.roomEditMode = true;
      this.roomName = room.nickname;
      this.editRoomId = room.id;
    },

    roomAddClick() {
      if (this.roomName != "") {
        this.setRoom(this.roomName);
        this.addNewRoomMode = false;
      } else {
        this.$store.dispatch("onError", "Room name can not be empty");
      }
    },

    async setRoom(new_nick) {
      this.loading = true;
      let nickname = new_nick;
      try {
        await this.$store.dispatch("createRoom", {nickname, isPublic: false, ...(this.copyFrom && {copyFrom: this.copyFrom})})
        this.$store.dispatch("onSuccess", "Room created");
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async getRooms() {
      try {
        await this.$store.dispatch("getRooms")
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },

    async editRoom(id, nickname) {
      this.loading = true;
      try {
        await this.$store.dispatch("renameRoom", {
          id,
          nickname
        })
        this.roomEditMode = false;
        this.roomName = "";
        this.addNewRoomMode = false;
        this.$store.dispatch("onSuccess", "Room updated");
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async removeRoom(roomid) {
      this.loading = true;

      try {
        await this.$store.dispatch("deleteRoom", roomid)
        this.roomName = "";
        this.$store.dispatch("onSuccess", "Room deleted");
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async setUserTranscript(data) {
      try {
        this.$store.commit("setUserTranscript", data);
        //this.$store.commit("setActiveVideoId", id);
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },

    addNewRoom() {
      if (this.payedSubscription) {
        this.addNewRoomMode = true;
        this.roomName = "";
      } else {
        this.$store.commit("showModal", "unlock_features");
      }
    },

    showRecordingsModal(room) {
      if (this.payedSubscription) {
        this.$store.commit("showModal", "recordings_modal");
        this.setUserTranscript(room.meetings);
      } else {
        this.$store.commit("showModal", "unlock_features");
      }
    },
  },
  computed: {
    rooms() {
      return this.$store.state.rooms.rooms
    },
    shareLink() {
      const {protocol, host} = window.location;
      return `${protocol}//${host}/room/`;
    },

    user() {
      return this.$store.state.user;
    },

    payedSubscription() {
      return true; //FIXME
    },
  },
  async mounted() {
    this.loading = true;
    await this.getRooms()
    this.loading = false;
  },
};
</script>

<style lang="scss">
.rooms {
  margin-bottom: 32px;
  opacity: 0.64;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  line-height: 24px;
  text-align: center;

  @media all and (max-width: 767px) {
    margin-bottom: 16px;
  }
}

.room_link {
  height: 64px;
  border-radius: 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;

  @media all and (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
    flex: none;
  }

  & + .room_link {
    margin-top: 16px;
  }

  .user_room_name {
    flex: 1 1 auto;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 15px;
    margin-bottom: 0;
    text-align: left;
    color: #000;

    a {
      color: #000;
    }

    @media all and (max-width: 767px) {
      padding-right: 10px;
    }

    @media all and (max-width: 376px) {
      max-width: 215px;
    }
  }

  .recs_wrap {
    flex: none;
  }

  .extras_drop {
    z-index: 2;
    top: 30px;
    width: 358px;
    right: 5px;

    @media all and (max-width: 767px) {
      width: calc(100vw - 32px);
      top: 32px;
      right: -16px;
    }
  }

  .room_extra {
    flex: none;
    width: 22px;
    height: 22px;
    background: url("../assets/img/mob_menu_icon.svg") no-repeat center / 34px;

    @media all and (max-width: 767px) {
      margin-left: 16px;
      background: url("../assets/img/mob_menu_icon.svg") no-repeat center / 30px auto;
    }
  }

  .recs {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: right;
    margin-right: 16px;
    align-items: center;
    display: none;

    @media all and (max-width: 1024px) and (min-width: 767px) {
      margin-right: 0;
    }

    span {
      cursor: pointer;
      white-space: nowrap;
    }

    @media all and (max-width: 767px) {
      span {
        display: none;
      }
    }

    &.active {
      display: flex;
    }

    img {
      width: 24px;
      height: 24px;
      margin-left: 16px;

      @media all and (max-width: 767px) {
        margin-left: 0;
      }
    }
  }
}

.add_room {
  color: #fc5a12;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  width: 100%;
  margin-top: 64px;
  height: 64px;
  border-radius: 16px;
  border: 1px solid #fc5a12;

  @media all and (max-width: 767px) {
    margin-top: 32px;
  }
}
</style>
